var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3h5v5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3H3v5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15 9 6-6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit);
export default __webpack_public_path__ + "static/media/split.abf14b1d14ae547aba4461d35c4bd7aa.svg";
export { ForwardRef as ReactComponent };